(function () {
  /* ------------------------------------------------------------------------
     THE HOME PAGE DESIGNER, AS THE 1-2-3 FLOW THE SALON-SET PAGES USE.
     19 SEP 2026.

     Mack: "Can we make it like the bundle deals with a step 1 2 and 3 and a
     visual of the choices made", and "keep it just like the one on the
     bundles ... so they can build an order without selecting a bundle".

     WHY THIS IS ITS OWN FILE
       assets/tod-solo.js is 64 KB and holds the thirty alphabets, the pen
       walk, the fitting arithmetic and the whole Add to cart path. The only
       way to write a theme file is to retype it whole, and a slipped
       character in the cart path is a shop that takes no money - the same
       reason sections/tod-single-cfg.liquid is a shim rather than an edit to
       tod-bundle.js. So that file owns the stitching and this one owns the
       LOOK, and they meet at window.TOD_SOLO_API.

     WHAT IT DOES, AND WHAT IT DELIBERATELY DOES NOT
       It does not build a second designer. It MOVES the controls the section
       already renders - the name boxes, the alphabet strip, the size pills,
       the cones, the apron tick, the notes and the buy box - into three
       panels, puts a numbered bar above them and a Back/Next under them, and
       adds the summary card. Every control underneath is the same element
       tod-solo.js is already drawing into, so nothing about the stitching,
       the measuring or the cart had to be taught about steps.

       That is also why this file can be deleted at any time and the page
       goes back to the one-page designer with nothing else changed.

     THE GATE
       Step 2 and step 3 need lettering, because a size button with no line
       to measure is a button that cannot answer. Until there is a name the
       later steps are reachable but say so, the same way the set pages do.
     ------------------------------------------------------------------------ */
  /* ---- THE SIX THE SHOP ACTUALLY SELLS -----------------------------------
     19 SEP 2026. Read off all seventeen orders rather than guessed. Counting
     one design per paid order that carried lettering (fourteen of them):
       Great Vibes    5 orders, 26 of the 69 garments
       Golden Butter  3 orders, 20 garments - and the second line in all
                      three of the orders that mixed two alphabets
       Alexander      2 orders, 13 garments
       Bubble Grove   2 orders, 13 garments
       Samantha       2 orders,  5 garments
       Emerson        1 order,   6 garments
     Twilight Crumbs and Happy Tangle came next and are the first two to
     promote if this list is ever revisited.

     Mack, 19 Sep: "On the fonts tab can you lead with those 6". The strip
     shows a window of six, so putting these first means the opening view of
     the picker is six alphabets that have been bought, not six that happen
     to sort first.

     CAVEAT WORTH KEEPING IN MIND: Great Vibes is also the default the page
     opens on, so part of its lead is the default being sticky rather than
     anybody choosing it. Fourteen orders is a small sample. If this list is
     re-cut later, cut it from orders placed AFTER a day when the default was
     something else, or the same font wins for the same circular reason.

     The order here is by orders first, garments as the tie-break. */
  var POPULAR = ['great-vibes', 'golden-butter', 'alexander', 'bubble-grove',
                 'samantha', 'emerson'];

  /* Whatever of POPULAR is in the list moves to the front, in POPULAR's own
     order; everything else keeps the order it came in. An id that is not in
     the list at all is simply not there - no gap, no error. */
  function lead(list, idOf) {
    var head = [], tail = [];
    list.forEach(function (f) {
      var i = POPULAR.indexOf(idOf(f));
      if (i > -1) head[i] = f; else tail.push(f);
    });
    var out = [];
    head.forEach(function (f) { if (f) out.push(f); });
    return out.concat(tail);
  }

  /* Nothing below belongs on a page without the designer on it - and the
     fetch wrapper especially must not follow tod-how.liquid onto the
     salon-set pages, where assets/tod-bundle.js reads the same manifest. */
  if (!document.getElementById('cb-form')) return;

  /* THE MANIFEST IS REORDERED AS IT ARRIVES, WHICH IS WHY THIS IS A FETCH
     WRAPPER AND NOT A SORT.
     assets/tod-solo.js builds its FONTS array from fonts.json and REPLACES
     the array when the manifest lands - so a list sorted from out here would
     be thrown away a few hundred milliseconds later, and the reference this
     file holds would be pointing at the old one. Reordering the JSON before
     that file ever sees it means the strip, the arrows and the dropdown all
     come out in the right order on their own, with no change to the 64 KB
     file and nothing to keep in step afterwards.
     This runs at the top level, before tod-solo.js takes its defer turn. */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = String((input && input.url) || input || '');
    if (!window.TOD_FONTS_URL || url !== window.TOD_FONTS_URL) {
      return _fetch.apply(this, arguments);
    }
    return _fetch.apply(this, arguments).then(function (r) {
      if (!r || !r.ok) return r;
      /* cloned, so that if anything below throws the original body is still
         unread and the caller gets exactly what it would have got */
      return r.clone().json().then(function (m) {
        if (m && m.fonts && m.fonts.length) {
          m.fonts = lead(m.fonts, function (f) { return f.id; });
        }
        return { ok: true, json: function () { return Promise.resolve(m); } };
      }).catch(function () { return r; });
    });
  };

  /* tod-how.liquid renders BEFORE the section writes its own <script src>, so
     this file's defer turn comes round first and the API is not there yet.
     Rather than move the render - which would mean retyping the 47 KB
     section, the one thing this whole arrangement exists to avoid - it waits
     for the handle and gives up after ten seconds, leaving the plain
     one-page designer exactly as it was. */
  if (!window.TOD_SOLO_API) {
    var waited = 0;
    var tick = setInterval(function () {
      waited += 40;
      if (window.TOD_SOLO_API) { clearInterval(tick); boot(); }
      else if (waited > 10000) { clearInterval(tick); }
    }, 40);
    return;
  }
  boot();

  function boot() {
  var API = window.TOD_SOLO_API;
  if (!API) return;
  var doc = document;
  var $ = function (id) { return doc.getElementById(id); };
  var S = API.S;

  var panel = $('cb-form');
  var grid = panel && panel.parentNode;
  if (!panel || !grid) return;
  if (doc.querySelector('.tsx-bar')) return;

  /* The built-in list, reordered IN PLACE - same objects, same array, so the
     alphabet already chosen keeps its identity and the strip's "this one is
     selected" test still matches. This is the list that is on screen for the
     moment before fonts.json lands (and for good, if it never does). */
  if (API.FONTS && API.FONTS.length) {
    var ordered = lead(API.FONTS, function (f) { return f.id; });
    API.FONTS.length = 0;
    Array.prototype.push.apply(API.FONTS, ordered);
    API.renderFonts();
  }

  /* ---- the three panels -------------------------------------------------- */
  var STEPS = [
    { n: 1, label: 'Your name',      hint: 'Looks good — pick your lettering next.' },
    { n: 2, label: 'Size & style',   hint: 'Pick the lettering and how big it sits.' },
    { n: 3, label: 'Color & order',  hint: 'Choose your thread, then add it to the cart.' }
  ];
  /* Said only while there is nothing to carry on WITH. It used to be step
     one's hint, which meant the line stayed up telling somebody to type a
     name they had already typed. */
  var NEED = 'Type your salon name to carry on.';

  function mk(tag, cls, html) {
    var e = doc.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  /* The steps bar goes ABOVE the whole two-column grid, not inside the
     right-hand column, so it reads across the preview as well - which is how
     /pages/signature has it. */
  var bar = mk('div', 'tsx-bar');
  STEPS.forEach(function (st) {
    var b = mk('button', 'tsx-step' + (st.n === 1 ? ' on' : ''),
      '<i>' + st.n + '</i><span>' + st.label + '</span>');
    b.type = 'button';
    b.setAttribute('data-step', st.n);
    b.addEventListener('click', function () { go(st.n); });
    bar.appendChild(b);
  });
  grid.parentNode.insertBefore(bar, grid);

  /* ---- THE HERO ----------------------------------------------------------
     Everything in this block belongs to sections/tod-solo.liquid, which is
     47 KB and is not retyped to change a few words and add a photograph -
     the same reasoning as the rest of this file, and the same reasoning
     tod-solo.js already uses to rewrite the announcement bar.
     IF THAT SECTION IS EVER REWRITTEN, make these changes there and delete
     this - a correction applied in two places is the one that goes stale. */

  /* It said "Two lines". The designer does three. */
  Array.prototype.forEach.call(doc.querySelectorAll('.sh-proof b'), function (b) {
    if (/^two lines$/i.test((b.textContent || '').trim())) b.textContent = 'Three lines';
  });

  /* THE DRAWING AND THE REAL THING, SIDE BY SIDE.
     Mack, 19 Sep: "add this to the right of the cape on the home page at the
     very top, and change the Cape font to Great Vibes ... with Threads on
     Design on that cape. So people can see how it turns out."

     The cape on the left is the same preview the designer draws, so the pair
     reads as promise and proof: this is what you build, and this is what
     came off the machine. Which is exactly why the drawn lettering is now
     the shop's own name, set the way the photograph has it - three lines,
     Great Vibes - and in WHITE rather than the gold the hero used to show.
     A drawing that does not match the photograph beside it undoes the
     comparison it was put there to make. */
  (function () {
    var vis = doc.querySelector('.sh-vis');
    var svg = vis && vis.querySelector('svg');
    if (!svg || vis.querySelector('.sh-shot')) return;

    Array.prototype.forEach.call(svg.querySelectorAll('text'), function (t) {
      if (t.parentNode) t.parentNode.removeChild(t);
    });
    var NS = 'http://www.w3.org/2000/svg';
    /* THE LINES, THEIR SIZES AND WHERE THEY SIT come from the snippet, not
       from here - see TOD_HERO_LINES in snippets/tod-solo-steps.liquid. The
       hero is the one thing on this page that gets nudged by eye, and this
       file is 23 KB that has to be retyped whole to change a number in it.
       The fallback below is only for a snippet that has not been updated. */
    var rows = window.TOD_HERO_LINES || [
      { t: 'Threads', y: 114.7, size: 18.7 },
      { t: 'on',      y: 127.9, size: 15.8 },
      { t: 'Design',  y: 143.3, size: 18.7 }
    ];
    rows.forEach(function (row) {
      var t = doc.createElementNS(NS, 'text');
      t.setAttribute('x', row.x != null ? row.x : 260);
      t.setAttribute('y', row.y);
      t.setAttribute('text-anchor', 'middle');
      t.setAttribute('font-family', "'Great Vibes',cursive");
      t.setAttribute('font-size', row.size);
      t.setAttribute('fill', row.fill || '#F1EFE9');
      t.setAttribute('stroke', 'rgba(0,0,0,.35)');
      t.setAttribute('stroke-width', '.45');
      t.setAttribute('paint-order', 'stroke');
      t.textContent = row.t;
      svg.appendChild(t);
    });

    /* the svg gets a box of its own so the two can share the row */
    var cape = doc.createElement('div');
    cape.className = 'sh-cape';
    svg.parentNode.insertBefore(cape, svg);
    cape.appendChild(svg);

    var url = window.TOD_HERO_SHOT;
    if (!url) return;
    var img = doc.createElement('img');
    img.className = 'sh-shot';
    img.alt = 'The shop name being stitched on the machine, and the finished cape';
    img.setAttribute('width', '800');
    img.setAttribute('height', '1362');
    /* The two-up layout is only switched on once the photograph has actually
       arrived. An asset that has not been uploaded yet leaves the hero
       exactly as it was rather than half a row. */
    img.onload = function () { vis.classList.add('sh-two'); };
    img.onerror = function () { if (img.parentNode) img.parentNode.removeChild(img); };
    img.src = url;
    vis.appendChild(img);
  })();

  /* "centred" in the caption under the preview - "Cutting cape · centred ·
     Gold" - is written by assets/tod-solo.js, the 64 KB file this whole
     arrangement exists in order not to retype. Mack, 20 Sep: the shop spells
     it the American way everywhere else now, so the caption is corrected
     here instead. It is rebuilt on every change, so it is watched rather
     than set once.
     IF tod-solo.js IS EVER REWRITTEN, fix the literal there (line 896) and
     delete this - a correction applied in two places is the one that goes
     stale. The same file still says "colour" in the hidden _Mixed property
     and "$75" in the banner; the banner is corrected by
     snippets/tod-ship.liquid and the property is never shown to a customer. */
  (function () {
    var cap = $('cb-capname');
    if (!cap) return;
    function fix() {
      var t = cap.textContent || '';
      if (t.indexOf('centred') > -1) cap.textContent = t.replace('centred', 'centered');
    }
    if (window.MutationObserver) {
      new MutationObserver(fix).observe(cap, { childList: true, characterData: true, subtree: true });
    }
    fix();
  })();

  var pane = [null, mk('div', 'tsx-pane'), mk('div', 'tsx-pane'), mk('div', 'tsx-pane')];
  [1, 2, 3].forEach(function (i) { panel.appendChild(pane[i]); });

  /* ---- move the section's own controls into the panels -------------------- */
  function take(sel, into) {
    var el = typeof sel === 'string' ? doc.querySelector(sel) : sel;
    if (el && into) into.appendChild(el);
    return el;
  }

  /* STEP 1 - the lettering card. */
  var card1 = mk('div', 'tsx-card');
  card1.appendChild(mk('h3', 'tsx-h',
    'Cape lettering <em>&mdash; up to three lines</em>'));
  var lineHost = mk('div', 'tsx-lines');
  card1.appendChild(lineHost);
  pane[1].appendChild(card1);
  /* The section's own "Step 1 - your name or salon name" block is an empty
     shell once its boxes have moved into the line cards, and it sits OUTSIDE
     the panes - so it was showing its heading above all three steps at once.
     It comes along into step one and goes quiet. Not deleted: ensureName3
     and the counters still reach for things by id, and an element that is
     merely hidden is still there to be found. */
  var stepName = $('cb-step-name');
  if (stepName) { pane[1].insertBefore(stepName, card1); stepName.hidden = true; }

  /* STEP 2 - the alphabet and the size. */
  var stepFont = $('cb-step-font'), stepHeight = $('cb-step-height');
  var card2 = mk('div', 'tsx-card');
  card2.appendChild(mk('h3', 'tsx-h', 'Lettering &amp; size'));
  pane[2].appendChild(card2);
  take(stepFont, card2);
  take(stepHeight, card2);

  /* STEP 3 - the cone, the apron, the notes and the buy box. */
  var stepThread = $('cb-step-thread');
  var card3 = mk('div', 'tsx-card');
  card3.appendChild(mk('h3', 'tsx-h', 'Thread color'));
  pane[3].appendChild(card3);
  take(stepThread, card3);
  /* The apron tick and the notes are the two remaining .cb-step blocks - they
     are found by what they CONTAIN rather than by position, because the apron
     one sits behind a Liquid if and is simply not there when aprons are sold
     out. */
  var addonStep = doc.querySelector('.cb-addon');
  if (addonStep) take(addonStep.closest('.cb-step'), pane[3]);
  var notes = $('cb-notes');
  if (notes) take(notes.closest('.cb-step'), pane[3]);
  var summary = mk('div', 'tsx-card tsx-sum');
  summary.appendChild(mk('h3', 'tsx-h', 'Your design'));
  var sumBody = mk('div', 'tsx-sum-body');
  summary.appendChild(sumBody);
  pane[3].appendChild(summary);
  var buy = doc.querySelector('.cb-buy');
  if (buy) pane[3].appendChild(buy);
  var bulk = doc.querySelector('.cb-bulk');
  if (bulk) pane[3].appendChild(bulk);

  /* The section numbers its own blocks Step 1 to Step 4. Inside a three-step
     flow those numbers argue with the bar at the top - "Step 3 Letter size"
     sitting inside "2 Size & style" is the sort of thing that makes somebody
     think they have lost their place. The card headings already say what each
     block is, so the numbers come off. "Optional", on the notes block, is not
     a number and stays. */
  [pane[2], pane[3]].forEach(function (p) {
    Array.prototype.forEach.call(p.querySelectorAll('.cb-lab b'), function (b) {
      if (/^step\s/i.test((b.textContent || '').trim())) b.style.display = 'none';
    });
  });

  /* ---- Back / Next ------------------------------------------------------- */
  var nav = mk('div', 'tsx-nav');
  var back = mk('button', 'tsx-back', 'Back'); back.type = 'button';
  var next = mk('button', 'tsx-next', 'Next'); next.type = 'button';
  var hint = mk('p', 'tsx-hint', '');
  nav.appendChild(back); nav.appendChild(next);
  panel.appendChild(nav); panel.appendChild(hint);
  back.addEventListener('click', function () { go(Math.max(1, S.step - 1)); });
  next.addEventListener('click', function () {
    if (S.step === 3) { var a = $('cb-add'); if (a && !a.disabled) a.click(); return; }
    if (!API.ready()) { shake(); return; }
    go(S.step + 1);
  });

  function shake() {
    var box = $('cb-name');
    if (box) { box.focus(); }
    hint.classList.remove('tsx-shake');
    void hint.offsetWidth;
    hint.classList.add('tsx-shake');
  }

  S.step = 1;
  function go(n) {
    /* A step nobody can answer yet is not opened - but the button is never
       dead, it says why. Same behaviour as the set pages. */
    if (n > 1 && !API.ready()) { shake(); n = 1; }
    S.step = n;
    [1, 2, 3].forEach(function (i) { pane[i].hidden = (i !== n); });
    Array.prototype.forEach.call(bar.children, function (b) {
      b.classList.toggle('on', +b.getAttribute('data-step') === n);
      b.classList.toggle('done', +b.getAttribute('data-step') < n);
    });
    back.hidden = (n === 1);
    next.textContent = n === 3 ? 'Add to cart' : 'Next';
    draw();
    if (n !== 1) bar.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  /* ---- step one: a card per line ----------------------------------------- */
  var NAME_ID = ['cb-name', 'cb-name2', 'cb-name3'];
  var CNT_ID = ['cb-c1', 'cb-c2', 'cb-c3'];

  function lineCard(n) {
    var id = 'tsx-line-' + n;
    var have = $(id);
    var box = $(NAME_ID[n]);
    if (!box) return null;
    if (have) return have;
    var card = mk('div', 'tsx-line'); card.id = id;
    var head = mk('div', 'tsx-line-head');
    head.appendChild(mk('em', null, API.LINE_WORD[n]));
    var right = mk('span', 'tsx-line-tools');
    var cnt = $(CNT_ID[n]);
    var cntWrap = cnt ? cnt.parentNode : null;
    if (cntWrap) right.appendChild(cntWrap);
    if (n > 0) {
      var rm = mk('button', 'tsx-rm', 'Remove'); rm.type = 'button';
      rm.addEventListener('click', function () { removeLine(n); });
      right.appendChild(rm);
    }
    head.appendChild(right);
    card.appendChild(head);
    card.appendChild(box);
    lineHost.appendChild(card);
    return card;
  }

  function removeLine(n) {
    var box = $(NAME_ID[n]);
    if (box) { box.value = ''; }
    S.names[n] = '';
    var cnt = $(CNT_ID[n]); if (cnt) cnt.textContent = '0';
    /* Line three is taken off the page altogether, because it only ever
       existed because somebody asked for it. Line two stays - it is part of
       what this shop sells and an empty box invites the second line. */
    if (n === 2) {
      var card = $('tsx-line-2');
      if (card && card.parentNode) card.parentNode.removeChild(card);
      S.rows = 2;
    }
    API.paint();
    draw();
  }

  /* The + Add another line button tod-solo.js made lives in the card now. */
  function placeAdd() {
    var add = $('cb-addline');
    if (add && add.parentNode !== card1) card1.appendChild(add);
    if (!add && !$('cb-name3')) {
      /* It removes itself once used; put a fresh one back when line three is
         taken away again. */
      var again = mk('button', 'cb-addline', '+ Add another line');
      again.type = 'button'; again.id = 'cb-addline';
      again.addEventListener('click', function () {
        API.ensureName3(); S.rows = 3;
        if (again.parentNode) again.parentNode.removeChild(again);
        lineCard(2);
        var b = $('cb-name3'); if (b) b.focus();
        API.paint(); draw();
      });
      card1.appendChild(again);
    }
  }

  /* THE DROPDOWN, REGROUPED.
     Moving six alphabets to the front splits their style groups, and
     renderFontSelect starts a new optgroup every time the label changes - so
     "Flowing script" would appear three times in the list and read like a
     fault. The six get a heading of their own at the top and everything else
     keeps the grouping it had. Rebuilt from the select's own contents, so it
     never needs to know what is in FONTS. */
  function regroupSelect() {
    var sel = $('cb-fsel');
    if (!sel || !sel.options.length) return;
    var chosen = sel.value, all = [];
    Array.prototype.forEach.call(sel.querySelectorAll('option'), function (o) {
      all.push({ id: o.value, name: o.textContent,
                 lab: (o.parentNode && o.parentNode.label) || '' });
    });
    var top = [], rest = [];
    all.forEach(function (f) { (POPULAR.indexOf(f.id) > -1 ? top : rest).push(f); });
    if (!top.length) return;
    top.sort(function (a, b) { return POPULAR.indexOf(a.id) - POPULAR.indexOf(b.id); });
    sel.innerHTML = '';
    function group(label, items) {
      if (!items.length) return;
      var g = doc.createElement('optgroup');
      g.label = label;
      items.forEach(function (f) {
        var o = doc.createElement('option');
        o.value = f.id; o.textContent = f.name;
        g.appendChild(o);
      });
      sel.appendChild(g);
    }
    group('Most ordered', top);
    /* Bucketed by label rather than by runs. Taking six alphabets out of the
       middle of the list CAN leave a style group split in two, and a list
       with "Flowing script" in it twice reads like a bug. Each heading is
       printed once, in the order it first appears. */
    var order = [], byLab = {};
    rest.forEach(function (f) {
      var k = f.lab || 'Lettering';
      if (!byLab[k]) { byLab[k] = []; order.push(k); }
      byLab[k].push(f);
    });
    order.forEach(function (k) { group(k, byLab[k]); });
    sel.value = chosen;
  }

  /* ---- the visual of the choices made ------------------------------------ */
  function draw() {
    regroupSelect();
    [0, 1, 2].forEach(function (n) { if ($(NAME_ID[n])) lineCard(n); });
    placeAdd();

    var ix = API.liveIdx(), ls = API.lines();
    sumBody.innerHTML = '';
    if (!ix.length) {
      sumBody.appendChild(mk('p', 'tsx-empty', 'Nothing typed yet.'));
    } else {
      var trio = API.sizeTrio(S.view === 'apron' ? 'apron' : 'cape');
      ix.forEach(function (n, i) {
        var t = API.threadOf(n), f = API.fontOf(n), h = trio[n];
        var row = mk('div', 'tsx-sum-row');
        row.appendChild(mk('span', 'tsx-dot', '')).style.background = t.hex;
        var txt = mk('div', 'tsx-sum-txt');
        txt.appendChild(mk('b', null, ls[i]));
        txt.appendChild(mk('span', null,
          f.name + ' &middot; ' + t.name + ' &middot; ' + h.label + ' ' + h.mm + ' mm'));
        row.appendChild(txt);
        sumBody.appendChild(row);
      });
      if (!API.oneFont() || !API.oneThread()) {
        sumBody.appendChild(mk('p', 'tsx-note',
          'Your lines use different ' +
          (!API.oneFont() && !API.oneThread() ? 'lettering and thread'
            : (!API.oneFont() ? 'lettering' : 'thread')) +
          '. We stitch them one at a time &mdash; it is on the mockup before anything is sewn.'));
      }
    }

    var ready = API.ready();
    hint.textContent = ready ? STEPS[S.step - 1].hint : NEED;
    next.disabled = (S.step === 3) && !!($('cb-add') && $('cb-add').disabled);
    Array.prototype.forEach.call(bar.children, function (b) {
      b.classList.toggle('locked', +b.getAttribute('data-step') > 1 && !ready);
    });
  }

  API.on(draw);
  go(1);
  }
})();
